import * as z from 'zod/v4';

import { drawNumberSchema, drawStateSchema } from '../draw/entry.js';
import { dateTimeSchema } from '../frameworks/entry.js';
import { productSchema } from '../product/entry.js';

export const dateDrawsResultDate = z.object({
  closeDate: dateTimeSchema,
  date: dateTimeSchema,
  drawNumber: drawNumberSchema,
  drawState: drawStateSchema,
  openDate: dateTimeSchema.optional().nullish(),
  product: productSchema,
});

export type DateDrawsResultDate = z.infer<typeof dateDrawsResultDate>;
